<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.addClass") }}</h3>
          </template>
          <template #right-element>
            <router-link :to="{name: 'ClasseList'}" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t("button.retour") }}
            </router-link>
          </template>
        </TopTemplate>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="messageError" class="alert alert-danger" role="alert">
          {{ $t("error.existClass") }}
        </div>
        <div v-if="!loading" class="ajout-container ajout-container-classe">
          <form novalidate @submit.prevent="onSubmitCreateClasse">
            <div class="row first-row">
              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12 select-wrapper">
                <div class="ajout-container__simple selected-bloc">
                  <label class="label">{{ $t("classe.form.niveau") }} <sup>*</sup></label>
                  <v-select
                    v-model="classe.selectedLevel"
                    :options="levels"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="v$.classe.selectedLevel.$error ? 'is-invalid' : ''"
                  >
                    <template #no-options="{search, searching, loading}">
                      {{ $t("info.noResult") }}
                    </template>
                  </v-select>
                  <span v-if="v$.classe.selectedLevel.$error" class="invalid-feedback">
                    {{ v$.classe.selectedLevel.$errors[0].$message }}
                  </span>
                </div>
              </div>

              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12">
                <div class="ajout-container__simple-input">
                  <label class="label">{{ $t("classe.form.name") }} <sup>*</sup></label>
                  <div class="simple-input">
                    <input v-model="classe.class_name" type="text" class="form-control" :class="v$.classe.class_name.$error ? 'is-invalid' : ''" />
                    <span v-if="v$.classe.class_name.$error" class="invalid-feedback">
                      {{ v$.classe.class_name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12 simple-input">
                <label class="label">{{ $t("classe.form.emploi") }}</label>
                <label class="input-image" for="otherDoc" @change="onFileChange">
                  <div class="file-name">
                    <span class="justify--" v-if="namedoc">
                      {{ namedoc }}
                    </span>
                    <span class="justify--- err article" v-else>
                      {{ $t("info.downloadDocs") }}
                    </span>
                  </div>
                  <div class="icon-upload">
                    <img src="../../assets/icons/VectorMsg.svg" />
                  </div>
                  <input id="otherDoc" type="file" class="d-none" accept=".pdf" tabindex="-1"
                /></label>
                <span class="notif-pdf">{{ $t("info.authFilePdf") }}</span>
              </div>
            </div>

            <div class="wrapper-top">
              <label class="label">{{ $t("classe.form.courses") }}</label>
              <div class="row items-wrapper mx-auto">
                <div
                  v-for="course in courses"
                  :key="course.id"
                  style="cursor: pointer"
                  class="matiere-item col-xl-3 col-lg-5 col-md-6 col-sm-6 col-xs-12"
                  :class="course.is_checked === true ? '' : 'matiere-background'"
                  @click="checkItem(course.id), (course.is_checked = !course.is_checked)"
                >
                  <span>{{ course.name }}</span>
                  <label class="container-checkbox">
                    <input v-model="selected" type="checkbox" :value="course.id" />
                    <span class="checkmark" :class="course.is_checked === true ? '' : 'chekedchek'" />
                  </label>
                </div>
              </div>
              <div class="text-end">
                <button type="submit" class="btn button btn-primary btn-soumettre" :disabled="loading">
                  <i class="icon-Check" />
                  {{ $t("button.envoi") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import ClasseService from "../../services/classe.service";
import CoursesService from "../../services/courses.service";
import {Validator} from "vee-validate";

/* const isUnique = (value) => {
        this.validating = true

        return Auth.checkDomain({fqdn: value}).then(({data}) => {
          this.validating = false
          return data

        })
        .catch(error => {
          this.validating = false
        })
      }
       */
export default {
  name: "AjoutClasse",
  components: {
    "v-select": vSelect,
    TopTemplate,
  },
  inject: ["$validator"],

  data() {
    return {
      v$: useValidate(),
      classe: new Form({
        selectedLevel: null,
        class_name: null,
        regime: "",
      }),
      levels: [],
      courses: [],
      className: null,
      idClass: "",
      selected: [],
      messageError: false,
      school_id: null,
      loading: false,
      is_created: false,
      namedoc: null,
    };
  },
  validations() {
    return {
      classe: {
        selectedLevel: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        class_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  mounted() {
    this.FilterClasses();
    this.school_id = this.$store.state.auth.user.school_id;
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
      this.namedoc = this.file.name;
      this.classe.timetable = "school/timetable" + this.namedoc;
    },
    checkItem(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((el) => el != id);
      } else {
        this.selected.push(id);
      }
    },
    FilterClasses() {
      this.loading = true;
      ClasseService.getFilter({
        params: {},
      }).then(
        (response) => {
          this.levels = response.data.types;
          this.CourseList();
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    CourseList() {
      CoursesService.getAll()
        .then(
          (response) => {
            this.courses = _.orderBy(response.data.data, "name");
            this.courses = this.courses.filter((element) => element.is_checked === true);
            // if(element.is_checked == true){
            //                   this.selected.push(element.id)
            //                }
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    // CourseList() {
    //     this.loading = true;
    //     CoursesService.getAll({
    //         params: {
    //             // limit: this.params.limit,
    //             // //sort: this.params.sort,
    //             // order: this.params.order,
    //             // class_school_id: this.params.class_school_id,
    //             // course_id: this.params.course_id,
    //             // class_type_id: this.params.class_type_id,
    //         },
    //     }).then(
    //         (response) => {
    //             this.courses = response.data.data;
    //             this.courses.map(function (item) {
    //                 return (item.select = false);
    //             });
    //
    //             this.loading = false;
    //         },
    //         (error) => {
    //
    //             this.loading = false;
    //         }
    //     );
    // },

    onSubmitCreateClasse() {
      this.loading = true;
      this.v$.$validate();
      let tab = [];
      this.selected.map((element) => {
        let id = element;
        let object = {id: id, teacher_id: null};
        element = object;
        tab.push(element);
      });
      if (!this.v$.$error) {
        /* const data = {
          class_type_id: this.classe.selectedLevel,
          courses: tab,
          name: this.classe.class_name,
          school_id: this.school_id,
          timetable: this.classe.timetable,
        };
         */

        let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("class_type_id", this.classe.selectedLevel);
        formData.append("name", this.classe.class_name);
        formData.append("courses", JSON.stringify(tab));
        formData.append("school_id", this.school_id);
        if (this.file) {
          formData.append("timetable", this.file);
        }
        ClasseService.create(formData)
          .then((data) => {
            this.messageError = false;
            this.is_created = true;
            this.loading = false;
            this.className = data.data.name;
            this.idClass = data.data.id;
            this.scrollToTop();
            localStorage.setItem("level", this.classe.selectedLevel);
            this.$router.push({
              name: "ClasseList",
            });
          })
          .catch((error) => {
            this.messageError = error.response.data.errors.name ? true : false;
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          });
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.form-classe {
  height: 35px;
  width: 300px;
  border-radius: 5px;
  border: 1px solid #dee2e6 !important;
}

img.img-class {
  margin-left: 275px;
  cursor: pointer;
}

label.label {
  width: 100%;
}

span.span {
  position: relative;
  bottom: 18px;
  left: 11px;
}
.notif-pdf {
  color: #34b9bb;
  font-weight: 400;
  font-size: 11px;
  font-family: "Inter", serif;
  margin-top: 5px;
}
</style>
